<template>
    <div class="undo-outfit" :class="{ active: showUndo }" @click="undoSwipe">
        Undo Reject
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        showUndo() {
            return this.undoOutfit && this.undoOutfit.products;
        },
        ...mapGetters({
            undoOutfit: "generatedOutfits/undoOutfit",
        }),
    },
    methods: {
        undoSwipe() {
            this.$store.commit("generatedOutfits/resetCurrentOutfitFromUndo");
        },
    },
    watch: {
        showUndo(value) {
            this.$emit("show-changed", value);
        },
    },
};
</script>

<style lang="scss" scoped>
.undo-outfit {
    position: absolute;
    top: 10px;
    right: -130px;
    font-size: 13px;
    color: #fff;
    background: #f2c0de;
    height: 42px;
    text-align: center;
    width: 130px;
    line-height: 42px;
    transition: all 0.4s ease-out;
    &.active {
        right: 0px;
    }
}
</style>
